import wandu from '../service/wandu';

const logout_state = {
    user_id: null,
    name: null, 
    avatar: '//m.wandu.cn/public/images/avatar_default.png',
    phone: null,
    egold: 0,
    coupon: 0,
    is_vip: 0,
    expire_time: 0,
    show_login: false,
};

export default {
    namespace: 'user',
    state: Object.assign({}, logout_state),
    reducers: {
        update_brief(state, action) {
            if (!action.payload) {
                return Object.assign({}, logout_state); 
            }
            const {userid,headimgurl,is_vip,user_name,egold,expire_time,coupon,phone} = action.payload;
            return {
                user_id: Number(userid), 
                name: user_name,
                    avatar: headimgurl.length>0 ? headimgurl : 'https://m.wandu.cn/public/images/avatar_default.png',
                phone: phone,
                egold: Number(egold),
                coupon: Number(coupon),
                is_vip: Number(is_vip),
                expire_time: Number(expire_time)
            }; 
        },

        show_login(state, action) {
            return Object.assign({}, state, {
                show_login: action.payload,
            }); 
        }
    },
    effects: {
        *brief(action, {put}) {
            const brief = yield wandu.user_brief().catch(e => {
                return null; 
            });
            if (brief) {
                yield put({
                    type: 'update_brief',
                    payload: brief, 
                });
            }
        },
        *logout(action, { put }) {
            yield wandu.logout().catch(e => {});
            window.location.href = window.location.href;
        }
    },
}



// WEBPACK FOOTER //
// ./src/model/user.js